import React, { useState } from "react";
import {
  Flex,
  Select,
  Badge,
  StatGroup,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
} from "@chakra-ui/react";

const ReportingKPIs = () => {

  const [period, setPeriod] = useState("This Quarter");

  const fakeData = {
    "This Quarter": {
      reportsIssuedOnTime: 18,
      reportsStillToBeIssued: 8,
      reportsIssuedLate: 3,
    },
    "This Month": {
      reportsIssuedOnTime: 6,
      reportsStillToBeIssued: 2,
      reportsIssuedLate: 1,
    },
    "This Year": {
      reportsIssuedOnTime: 72,
      reportsStillToBeIssued: 12,
      reportsIssuedLate: 8,
    },
  };

  const kpis = fakeData[period];

  return (
    <Flex direction="column" gap={8} borderBottom={"1px solid"} borderColor={"grey.200"} pb={{ base: 8, lg: 16 }}>
      
      <Flex justifyContent="space-between" alignItems="center" >
        <Select
          w="fit-content"
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
        >
          <option value="This Quarter">This Quarter</option>
          <option value="This Month">This Month</option>
          <option value="This Year">This Year</option>
        </Select>
      </Flex>



        <StatGroup as={Flex} w={"100%"} justify={"space-between"}>
          
          <Stat>
            <StatLabel  as={Badge} colorScheme="success">Issued on time</StatLabel>
            <StatNumber>{kpis.reportsIssuedOnTime}</StatNumber>
            <StatHelpText>
              <StatArrow type='increase' />
              23.36%
            </StatHelpText>
          </Stat>

          

          <Stat>
            <StatLabel  as={Badge} colorScheme="warning">Issued late</StatLabel>
            <StatNumber>{kpis.reportsIssuedLate}</StatNumber>
            <StatHelpText>
              <StatArrow type='decrease' />
              -3%
            </StatHelpText>
          </Stat>

          <Stat>
            <StatLabel as={Badge} colorScheme="error">Still to be issued</StatLabel>
            <StatNumber>{kpis.reportsStillToBeIssued}</StatNumber>
            <StatHelpText>
              <StatArrow type='increase' />
              +50.12%
            </StatHelpText>
          </Stat>

          
      </StatGroup>
        
  
    </Flex>
  );
};

export default ReportingKPIs;
